import { IFormattedStat } from '@ifit/gateway-wolf-dashboard-service';
import { Text } from './text';

const fallbackValue = '— —';

const duration = { label: Text.duration, type: 'duration' };
const distance = { label: Text.distance, type: 'distance' };
const cals = { label: Text.calories, type: 'cals' };
const elevationGain = { label: Text.elevation, type: 'elevation-gain' };
const pace = { label: Text.pace, type: 'pace' };
const averageWatts = { label: Text.averagePower, type: 'avg-watts' };
const averageSplit = { label: Text.averageSplit, type: '500M-split' };

type StatLabels = { label: string; type: string }[];

const statLabelToFallbackStat = (statLabel): IFormattedStat => {
  return {
    type: statLabel.type,
    label: statLabel.label,
    formatted: fallbackValue,
    unit: '',
    value: fallbackValue,
  };
};

const getStatLabelsFromCode = (equipmentType: string): StatLabels => {
  switch (equipmentType) {
    case 'cycle':
      return [duration, distance, cals, averageWatts, elevationGain];
    case 'row':
      return [duration, distance, cals, averageSplit, averageWatts];
    case 'run':
    default:
      return [duration, distance, cals, elevationGain, pace];
  }
};

const getDefaultUserStats = (equipmentType: string): IFormattedStat[] => {
  return getStatLabelsFromCode(equipmentType).map(statLabelToFallbackStat);
};

export { getDefaultUserStats };
